import LoyaltySingleOffer from './loyalty-single-offer.vue';

export default LoyaltySingleOffer;
